import React from 'react';
import InvestorSecondaryMarketContentSC, {
  TableContentWrapSC,
} from './investor-secondary-market-content.styled';
import SecondaryMarketTable from '../secondary-market-table';
import { withRouter } from 'react-router-dom';
import BiddingsTable from '../biddings-table';

const InvestorSecondaryMarketContent = () => {
  return (
    <InvestorSecondaryMarketContentSC>
      <TableContentWrapSC>
        <SecondaryMarketTable hasPagination />
      </TableContentWrapSC>
      <TableContentWrapSC>
        <BiddingsTable hasPagination hasAdditionalTop />
      </TableContentWrapSC>
    </InvestorSecondaryMarketContentSC>
  );
};

export default withRouter(InvestorSecondaryMarketContent);
